/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Status_HistoryInputs */

const vi_order_status_history = /** @type {(inputs: Order_Status_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lịch sử trạng thái`)
};

/**

* @param {Order_Status_HistoryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_status_history = /** @type {((inputs?: Order_Status_HistoryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Status_HistoryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_status_history(inputs)
});